import { createSelector } from '@reduxjs/toolkit';

const basketData = (state = {}) => state.basket;

export const getUserBasket = createSelector(
  basketData,
  (basketData) => basketData.user_basket,
);

export const getProductsInBasket = createSelector(
  basketData,
  (basketData) => basketData.user_products,
);

export const getTotalNumberOfProductsInBasket = createSelector(
  getProductsInBasket,
  (basketData) => basketData.length,
);

export const totalBasketPrice = createSelector(getProductsInBasket, (products) => {
  const price = products.reduce((prev, curr) => {
    return prev + curr.price.value;
  }, 0);
  return price;
});

const getPrice = (products) => {
  const total = products.reduce((prev, curr) => {
    return prev + curr.price.value;
  }, 0);
  return total;
};

export const getTotalPriceOfBasket = createSelector(
  getProductsInBasket,
  (products) => {
    if (products?.length > 0) {
      const temp = products[0];
      const currency = temp?.price?.currency?.symbol;
      const short_code = temp?.price?.currency?.short_code;
      const total_price = getPrice(products);
      return { currency, total_price, short_code };
    } else {
      return { currency: '$', total_price: 0, short_code: 'USD' };
    }
  },
);

export const getPartnerConfig = createSelector(
  basketData,
  (basketData) => basketData.partner_config,
);

export const getIsCarDelivery = createSelector(
  getProductsInBasket,
  getUserBasket,
  (products, basket) => {
    let isCarDelivery = false;
    products.forEach((product) => {
      if (
        product?.unit === 'bunch' ||
        product?.unit === 'carton' ||
        basket?.all_products > 40
      ) {
        isCarDelivery = true;
      }
    });
    return isCarDelivery;
  },
);

export const getDeliveryLocations = createSelector(
  basketData,
  (basketData) => basketData.delivery_locations,
);

export const getLoadingCoupon = createSelector(
  basketData,
  (basketData) => basketData?.ui?.loading_coupon,
);

export const getCoupon = createSelector(
  basketData,
  (basketData) => basketData.coupon,
);

export const getCouponValue = createSelector(
  basketData,
  (basketData) => basketData?.coupon?.coupon_value || 0,
);

export const getBasket = createSelector(
  basketData,
  (basketData) => basketData.customer_basket,
);

export const getCreating = createSelector(
  basketData,
  (basketData) => basketData.ui.adding_product,
);

export const getLoggedInCart = createSelector(
  basketData,
  (basketData) => basketData.loggedInCart,
);

// export const getTotalBasketPrice = createSelector(
//   getProducts,
//   totalBasketPrice,
//   (products, total) => {
//     if (products.length > 0) {
//       const temp = products[0];
//       const currency = temp?.price?.currency?.symbol;
//       return { currency, total };
//     } else {
//       return { currency: '$', total: 0 };
//     }
//   },
// );

// export const getWeightOfProductsInBasket = createSelector(
//   getProductsInBasket,
//   (products) => {
//     const weight = products.reduce((prev, curr) => {
//       return prev + curr.net_weight;
//     }, 0);
//     return weight;
//   },
// );

// export const getLoading = createSelector(
//   basketData,
//   (basketData) => basketData.ui.loading,
// );

// export const getLoadingProductBasket = createSelector(
//   basketData,
//   (basketData) => basketData.ui.loading_products_in_basket,
// );

// export const getAddingProduct = createSelector(
//   basketData,
//   (basketData) => basketData.ui.adding_product,
// );

// export const getPageStats = createSelector(
//   basketData,
//   (basketData) => basketData.ui.stats,
// );
